const PERFIL = 1
const CIUDADANOS_RESUMEN_TRAMITES = 2
const CIUDADANOS_AFILIACION_PARTIDO = 3
const CIUDADANOS_FICHA_AFILIACION = 4
const CIUDADANOS_RENUNCIA_PARTIDO_POLITICO = 5
const CIUDADANOS_GENERACION_CERTIFICADO = 6
const CIUDADANOS_REGISTRO_HISTORICO = 7
const CIUDADANOS_SOLICITUDES_HISTORICAS = 8
const CIUDADANOS_FAQ = 9
const PARTIDO_SOLICITUDES_PENDIENTES = 10
const PARTIDO_SOLICITUDES_REVISADAS = 11
const PARTIDO_AFILIACION_CIUDADANO = 12
const PARTIDO_FICHA_CIUDADANO = 13
const PARTIDO_RENUNCIAS_AFILIACION = 14
const CIUDADANOS_RECLAMOS = 15

export default {
  PERFIL: PERFIL,
  CIUDADANOS_RESUMEN_TRAMITES: CIUDADANOS_RESUMEN_TRAMITES,
  CIUDADANOS_AFILIACION_PARTIDO: CIUDADANOS_AFILIACION_PARTIDO,
  CIUDADANOS_FICHA_AFILIACION: CIUDADANOS_FICHA_AFILIACION,
  CIUDADANOS_RENUNCIA_PARTIDO_POLITICO: CIUDADANOS_RENUNCIA_PARTIDO_POLITICO,
  CIUDADANOS_GENERACION_CERTIFICADO: CIUDADANOS_GENERACION_CERTIFICADO,
  CIUDADANOS_REGISTRO_HISTORICO: CIUDADANOS_REGISTRO_HISTORICO,
  CIUDADANOS_SOLICITUDES_HISTORICAS: CIUDADANOS_SOLICITUDES_HISTORICAS,
  CIUDADANOS_FAQ: CIUDADANOS_FAQ,
  PARTIDO_SOLICITUDES_PENDIENTES: PARTIDO_SOLICITUDES_PENDIENTES,
  PARTIDO_SOLICITUDES_REVISADAS: PARTIDO_SOLICITUDES_REVISADAS,
  PARTIDO_AFILIACION_CIUDADANO: PARTIDO_AFILIACION_CIUDADANO,
  PARTIDO_FICHA_CIUDADANO: PARTIDO_FICHA_CIUDADANO,
  PARTIDO_RENUNCIAS_AFILIACION: PARTIDO_RENUNCIAS_AFILIACION,
  CIUDADANOS_RECLAMOS: CIUDADANOS_RECLAMOS
}
